import PropTypes from 'prop-types';
import React from 'react';
import Link from '../../components/link/internal-link';
import { Interpolate } from 'react-i18next';
import withTranslate from '../../hoc/with-translate';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './no-search-results.scss';
import EmptyStates from '../empty-states';

const getLink = (alternativeType, query, text) => {
  const location = {
    pathname: `/search/${alternativeType}`,
    query: { query },
  };

  return (
    <Link className={styles.link} to={location}>
      {text}
    </Link>
  );
};

function renderNoResults(t) {
  return (
    <EmptyStates
      className={styles.container}
      title={t('no-search-results.no-results-found-title')}
      content={t('no-search-results.try-again')}
    />
  );
}

function renderNoTypeFound(query, type, alternativeType, t) {
  const typeName = t(`no-search-results.${type}`);
  const alternativeTypeName = t(`no-search-results.${alternativeType}`);
  const tryAgain = (
    <div>
      <Interpolate
        i18nKey={`no-search-results.no-type-found-content.${type}`}
        query={<span className={styles.term}>
          {query}
        </span>}
      />
      <br/>
      <Interpolate
        i18nKey="no-search-results.no-type-found-try-again-content"
        link={getLink(alternativeType, query, alternativeTypeName)}
      />
    </div>
  );
  return (
    <EmptyStates
      className={styles.container}
      title={t('no-search-results.no-type-found-title', { type: typeName })}
      content={tryAgain}
    />
  );
}

export const NoSearchResults = ({ type, alternativeType, query, t, resultCounts, borderWidth }) => {
  return (
    <div style={{ marginTop: -borderWidth }}>
      {resultCounts.length > 0 ? renderNoTypeFound(query, type, alternativeType, t) : renderNoResults(t)}
    </div>
  );
};

NoSearchResults.propTypes = {
  query: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  alternativeType: PropTypes.string.isRequired,
  search: PropTypes.object.isRequired,
  borderWidth: PropTypes.number.isRequired,
  t: PropTypes.func,
  resultCounts: PropTypes.array,
};

export default withTranslate(withCardBorderWidth(withFontClassName(NoSearchResults)));



// WEBPACK FOOTER //
// ./app/components/no-search-results/no-search-results.js